<template>
  <div>
    <router-view :profile="profile"/>
    <div class="IMAGE-HOLDER">
      <div v-background="image" class="HEADER-IMAGE"  />
    </div>


    <div class=" container d-flex fd-column m-b-2 m-b-4:t">
      <div class="w-100">
        <profile-summary
            ref="summary"
            :profile="profile"
            :class="{
              'TOP': summaryPosition === 'top',
              'BOTTOM': summaryPosition === 'bottom'
            }"
            class=""
            @reviews-clicked="scrollToReviews"
        />
      </div>
      <div ref="sections">
        <h5 class="HEADING-LAYOUT">
          Areas of Expertise
        </h5>
        <occupation-tabs />
        <div v-if="showAllReviews" class="SECTION">
          <review-section
              :profile="{ service_provider : {id : profile.service_provider.id }
              }"
              ref="reviews" />
        </div>
        <div v-else class="SECTION">
          <service-section :services="profile.servicesList" />
          <work-area-section :profile="profile" />
          <photo-section :photos="profile.assets || []" :occupation="profile.occupationName"/>
          <review-section :profile="profile" ref="reviews" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import ProfileSummary from './components/ProfileSummary';
import ServiceSection from './components/ServiceSection';
import WorkAreaSection from './components/WorkAreaSection';
import PhotoSection from './components/PhotoSection';
import ReviewSection from './components/ReviewSection';
import OccupationTabs from './components/OccupationTabs';

const IMAGES = {
  default: require('./assets/occupations/default.jpg'),
  carpenter: require('./assets/occupations/carpenter.jpg'),
  deck_builder: require('./assets/occupations/deck_builder.jpg'),
  electrician: require('./assets/occupations/electrician.jpg'),
  general_contractor: require('./assets/occupations/general_contractor.jpg'),
  handyman: require('./assets/occupations/handyman.jpg'),
  landscaper: require('./assets/occupations/landscaper.jpg'),
  painter: require('./assets/occupations/painter.jpg'),
  plumber: require('./assets/occupations/plumber.jpg'),
  lawn_and_garden_care: require('./assets/occupations/lawn_and_garden_care.jpg'),
  appliance_professional: require('./assets/occupations/appliance_professional.jpg'),
  pest_control: require('./assets/occupations/pest_control.jpg'),
  pool_cleaner: require('./assets/occupations/pool_cleaner.jpg'),
  'concrete_installer/repairer': require('./assets/occupations/concrete_masonry.jpg'),
};

export default {
  name: 'pro-public-profile',
  components: {
    ProfileSummary,
    ServiceSection,
    WorkAreaSection,
    PhotoSection,
    ReviewSection,
    OccupationTabs,
  },
  props: {
    profile: {
      type: Object,
      required: true,
    },
    serviceProviderOccupationId: {
      type: [String, Number],
      required: false,
    },
  },
  data () {
    return {
      summaryPosition: '',
    };
  },
  computed: {
    image () {
      return IMAGES[this.profile.occupation_name] || IMAGES.default;
    },
    showAllReviews () {
      return this.$route.meta.reviews;
    },
  },
  mounted () {
    this.fetch({ identifiers: this.profile.service_provider.identifier });
    this.$nextTick(() => {
      document.addEventListener('scroll', this.handleScroll);
    });
  },
  beforeDestroy () {
    document.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapActions('fullproprofile', ['fetchProProfile', 'fetch']),
    scrollToReviews () {
      this.$refs.reviews.$el.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });
    },
    handleScroll () {
      if (this.$device.isMobile) {
        this.summaryPosition = '';
        return;
      }

      const scrollTop = window.pageYOffset;

      const summaryHeight = this.$refs.summary.$el.clientHeight;
      const summaryBottom = summaryHeight + scrollTop;

      const sectionsHeight = this.$refs.sections.clientHeight;
      const sectionsTop = this.$refs.sections.offsetTop;
      const sectionsBottom = sectionsHeight + sectionsTop;

      if (summaryHeight >= sectionsHeight) {
        this.summaryPosition = ''; // Summary is taller than sections so do nothing
        return;
      }

      if (summaryBottom >= sectionsBottom) {
        this.summaryPosition = 'bottom'; // Summary is at bottom of sections
      } else if (scrollTop >= sectionsTop) {
        this.summaryPosition = 'top'; // Summary is between sections
      } else {
        this.summaryPosition = ''; // Summary is at beginning
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";

$top-margin: 70px;


.SECTION {
  @include padding(1, 3);
  @include padding-top(1, 2);
  @include margin-bottom(2, 4);
  background-color: white;
  border: 1px solid $color-gray30;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);

  &:last-child {
    margin-bottom: 0;
  }
}

.IMAGE-HOLDER {
  position: relative;
  height: 120px;
}
.HEADER-IMAGE {
    height: 100%;

}

.HEADING-LAYOUT {
    @include h4();
    @include margin(3 0 3 1);
}
</style>
